import type { GetDesignerPerformanceSummaryResponseType } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import { projectsKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

interface UseGetDesignerPerformanceSummaryParams {
  completedAtFrom?: string;
  completedAtTo?: string;
  designerId: number;
}

export const useGetDesignerPerformanceSummary = ({
  completedAtFrom,
  completedAtTo,
  designerId,
}: UseGetDesignerPerformanceSummaryParams) =>
  useQuery<GetDesignerPerformanceSummaryResponseType>({
    enabled: Number.isFinite(designerId) && designerId > 0,
    queryFn: async () => {
      const params = new URLSearchParams();

      if (completedAtFrom) params.set("completedAtFrom", completedAtFrom);
      if (completedAtTo) params.set("completedAtTo", completedAtTo);

      const qs = params.toString();
      const url = qs
        ? `/projects/designers/${designerId}/performance/summary?${qs}`
        : `/projects/designers/${designerId}/performance/summary`;

      return await apiClient.url(url).get().json();
    },
    queryKey: projectsKeys.designerPerformanceSummary(designerId, {
      completedAtFrom,
      completedAtTo,
    }),
    staleTime: 30_000,
  });
